import request from '@/utils/request'

export function queryFaceThirdCallLogs(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/fee.queryFaceThirdCallLogs',
      method: 'post',
      data: params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '查询同步日志失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}